import { call, all }   from 'redux-saga/effects';
import getApps         from './get_apps'
import getUserInfo     from './get_user_info'
import setTeacherId    from './set_teacher_id'
import getStudentsInfo from './get_students_info'
import signOut         from './signOut'
import recordEntry     from './record_entry'

export default function* indexSaga(){
  yield all([
    call(recordEntry),
    call(getApps),
    call(getUserInfo),
    call(getStudentsInfo),
    call(setTeacherId),
    call(signOut)
  ])
}